/* eslint-disable */
import React, { useState } from 'react';
import SEO from './SEO';
import './styles/styles.css';

const containerStyle = {
  minHeight: '60vh',
  backgroundColor: '#FFF',
  padding: '4rem 2rem',
  fontFamily: 'Raleway, sans-serif',
};

const innerStyle = {
  maxWidth: 680,
  margin: '0 auto',
};

const headingStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '2.25rem',
  fontWeight: 700,
  color: '#261136',
  marginBottom: '0.5rem',
};

const subStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.05rem',
  color: '#555',
  marginBottom: '2.5rem',
  lineHeight: 1.6,
};

const cardStyle = {
  backgroundColor: '#F9F6FC',
  borderRadius: 12,
  padding: '1.75rem',
  marginBottom: '1.5rem',
};

const cardHeading = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.15rem',
  fontWeight: 700,
  color: '#261136',
  marginBottom: '0.4rem',
};

const cardText = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.97rem',
  color: '#555',
  lineHeight: 1.6,
};

const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

const inputStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1rem',
  padding: '12px 16px',
  borderRadius: 8,
  border: '1px solid #DDD',
  outline: 'none',
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 120,
  resize: 'vertical',
};

const submitStyle = {
  display: 'inline-block',
  backgroundColor: '#7B1FA2',
  color: '#FFF',
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '1rem',
  padding: '13px 28px',
  borderRadius: 999,
  border: 'none',
  cursor: 'pointer',
  alignSelf: 'flex-start',
};

const Support = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    window.location.href = `mailto:contact@bins-storage.com?subject=Support request from ${encodeURIComponent(form.name)}&body=${encodeURIComponent(form.message)}%0A%0AReply to: ${encodeURIComponent(form.email)}`;
    setSent(true);
  };

  return (
    <>
      <SEO
        title="Support | Bins Storage"
        description="Get help with your Bins Storage account, schedule a pickup or delivery, or reach out to our team directly."
        path="/support"
      />
      <div style={containerStyle}>
        <div style={innerStyle}>
          <h1 style={headingStyle}>Support</h1>
          <p style={subStyle}>
            We're here to help. Reach out via the form below or email us directly
            and we'll get back to you within one business day.
          </p>

          {/* Email card */}
          <div style={cardStyle}>
            <div style={cardHeading}>📧 Email Us</div>
            <div style={cardText}>
              <a href="mailto:contact@bins-storage.com" style={{ color: '#7B1FA2' }}>
                contact@bins-storage.com
              </a>
              {' '}– typical response within 1 business day.
            </div>
          </div>

          {/* FAQ card */}
          <div style={cardStyle}>
            <div style={cardHeading}>📖 Browse the FAQ</div>
            <div style={cardText}>
              Many questions are answered in our{' '}
              <a href="/FAQ" style={{ color: '#7B1FA2' }}>FAQ page</a> – pricing,
              moving fees, service areas, how to get started, and more.
            </div>
          </div>

          {/* Contact form */}
          <div style={{ ...cardStyle, backgroundColor: '#FFF', border: '1px solid #EDE0F7' }}>
            <div style={cardHeading}>💬 Send a Message</div>
            {sent ? (
              <p style={{ ...cardText, color: '#7B1FA2', fontWeight: 600 }}>
                Your message has been sent. We'll be in touch soon!
              </p>
            ) : (
              <form style={formStyle} onSubmit={handleSubmit}>
                <input
                  style={inputStyle}
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
                <input
                  style={inputStyle}
                  type="email"
                  name="email"
                  placeholder="Your email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
                <textarea
                  style={textareaStyle}
                  name="message"
                  placeholder="How can we help?"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
                <button type="submit" style={submitStyle}>
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
